<template>
	<PaymentConditionPill
		:classes="['bg-primary-white', 'text-orange-900', 'orange-border']"
		:height="props.height"
		:width="props.width">
		<template #icon>
			<svg
				width="11"
				height="10"
				class="icon"
				color="var(--primary-orange)">
				<use xlink:href="#___icon___fixed-payment"></use>
			</svg>
		</template>
		<template #content>
			<span>
				{{ props.content.fix_product }}
			</span>
		</template>
	</PaymentConditionPill>
</template>

<script setup lang="ts">
import { defineProps } from "vue"

// Components
import PaymentConditionPill from "./PaymentConditionPill.vue"

interface Props {
	content: { [key: string]: string }
	height?: number
	width?: number
}

const props = defineProps<Props>()
</script>
